import React, { Component } from 'react';
import { Tooltip } from 'reactstrap';
import Img from '../../StableImage';
import Champion from './Champion';
import Entity from './Entity';
import './Fountain.css';

export default class Reward extends Component {

  state = {

    tooltip: null
  }

  toggleTooltip (tooltip, touch) {

    if (tooltip === this.state.tooltip && this.state.tooltipDate && new Date() - this.state.tooltipDate < 500)
      return;

    if (touch) {
      
      if (this.tooltipTimeout)
        clearTimeout(this.tooltipTimeout);

      this.setState({tooltip: tooltip === this.state.tooltip ? null : tooltip, tooltipDate: new Date()});
      this.tooltipTimeout = setTimeout(() => this.toggleTooltip(null), 3000);
      return;
    }

    this.setState({tooltip: tooltip === this.state.tooltip ? null : tooltip});
  }

  render () {

    let tooltips = []

    let src = this.props.src;
    let manager = this.props.manager;

    return (
      <div className={"fountain-scene fight-scene " + (manager.controller.name)}>
        <div className="game-fountain">
          <Entity static src={ src.entity } onSelect={() => {}}/>
        </div>
        {
          src.active &&
          <div className="fountain-choices">
          {
            src.choices.map((c,i) => 
                <div key={i} className="fountain-choice" onClick={() => manager.run.room.fountain.select(c.type)}>
                  {
                      (() => {
                        switch (c.type) {
                        case "rest": return (
                          <div className="fountain-choice-inner">
                            <h3>Heal</h3>
                            <span>Recover&nbsp;<span className="fountain-info-hp">{c.value}</span>&nbsp;HP.</span>
                          </div>
                          );
                        case "worship": return (
                          <div className="fountain-choice-inner">
                            <h3>Worship</h3>
                            <span>Gain&nbsp;<span className="fountain-info-exp">{c.value}</span>&nbsp;exp.</span>
                          </div>
                          );
                        case "conjure": return (
                          <div className="fountain-choice-inner">
                            <h3>Conjure</h3>
                            <span>Add a new card to your deck.</span>
                          </div>
                          );
                        case "ponder": return (
                          <div className="fountain-choice-inner">
                            <h3>Ponder</h3>
                            <span>Watch a scene.</span>
                          </div>
                          );
                        case "purify": return (
                          <div className="fountain-choice-inner">
                            <h3>Purify</h3>
                            <span>Decrease your minimum deck size by 1.</span>
                          </div>
                          );
                        case "wish": return (
                          <div className="fountain-choice-inner">
                            <h3>Wish</h3>
                            <span>Get a random relic.</span>
                          </div>
                          );
                        case "cleanse": return (
                          <div className="fountain-choice-inner">
                            <h3>Cleanse</h3>
                            <span>Lose&nbsp;<span className="fountain-info-corruption">{c.value}</span>&nbsp;corruption.</span>
                          </div>
                          );
                        }
                      })()
                    }
                </div>
            )
          }
          </div>
        }
        {/*<div className="shop-sign">
          <div className="shop-name">{ "Fountain" }</div>
          <div className="shop-description">The air is quiet and the water is fresh, filled with magical energy. Help yourself, traveller.</div>
        </div>*/}
      </div>
    );
  }
}

